import React from 'react';
import { DAYS } from '../consts';
import MedicationReminderIcon from '../assets/icons/medcine_reminder.svg';
function MedicationsTable({ medications }) {
    const getDays = (days) => {
        var _a;
        if (!days)
            return '';
        if (days.length === 7)
            return 'Every day';
        return (_a = days === null || days === void 0 ? void 0 : days.split('')) === null || _a === void 0 ? void 0 : _a.map((d) => DAYS[d]).join(' | ');
    };
    return (React.createElement("div", { className: 'wrap-medications' },
        React.createElement("table", { className: `table medication-table ${!(medications === null || medications === void 0 ? void 0 : medications.length) && 'empty'}` },
            React.createElement("thead", null,
                React.createElement("tr", { className: 'header-card' },
                    React.createElement("th", { className: 'td-name' }, "Name of medication*"),
                    React.createElement("th", { className: 'td-dosage' }, "Dosage"),
                    React.createElement("th", { className: 'td-times' }, "Times per day"),
                    React.createElement("th", { className: 'td-frequency' }, "Frequency"))),
            React.createElement("tbody", null, (medications === null || medications === void 0 ? void 0 : medications.length) ?
                medications === null || medications === void 0 ? void 0 : medications.map((m, i) => React.createElement("tr", { key: i },
                    React.createElement("td", { className: 'td-name' }, m.name),
                    React.createElement("td", { className: 'td-dosage' }, m.dosage),
                    React.createElement("td", { className: 'td-times' }, m.timesPerDay),
                    React.createElement("td", { className: 'td-frequency' }, getDays(m.days))))
                :
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 4, className: 'empty-medication-section' },
                            React.createElement("img", { className: 'mb-2', src: MedicationReminderIcon, alt: 'clock reminder' }),
                            React.createElement("p", null, "No medications have been added to the list")))))));
}
export default MedicationsTable;
